const PILI_BLUE = "#1C3D55";
const PILI_LIME = "#C9DD3B";
const PILI_DARK = "#0b0c0f";
const PILI_MUTED = "#5A5A5A";
const PILI_LIGHT_BLUE_BG = "#eaf2ff";

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "100vh",
    backgroundColor: PILI_LIGHT_BLUE_BG,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  header: {
    padding: "24px",
    backgroundColor: PILI_BLUE,
  },
  logo: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    objectFit: "contain" as const,
  },
  main: {
    maxWidth: "720px",
    margin: "0 auto",
    padding: "48px 24px 80px",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    padding: "48px",
    boxShadow: "0 4px 24px rgba(28, 61, 85, 0.08)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    color: PILI_DARK,
    marginBottom: "8px",
    letterSpacing: "-0.02em",
  },
  lastUpdated: {
    fontSize: "14px",
    color: PILI_MUTED,
    marginBottom: "40px",
    paddingBottom: "24px",
    borderBottom: `2px solid ${PILI_LIME}`,
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: PILI_BLUE,
    marginBottom: "12px",
  },
  paragraph: {
    fontSize: "15px",
    color: PILI_MUTED,
    lineHeight: "1.7",
    marginBottom: "12px",
  },
  link: {
    color: PILI_BLUE,
    textDecoration: "none",
    fontWeight: "500",
  },
};

export default function TermsPage() {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <a href="/">
          <img src="/app-icon.png" alt="Pili" style={styles.logo} />
        </a>
      </header>

      <main style={styles.main}>
        <div style={styles.card}>
          <h1 style={styles.title}>Terms and Conditions</h1>
          <p style={styles.lastUpdated}>Last updated: February 3, 2026</p>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>1. Role of the Service</h2>
            <p style={styles.paragraph}>
              The Service facilitates payment initiation between users through third-party payment
              processors. We do not hold, store, or control funds on behalf of users and do not
              provide accounts, wallets, or stored value.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>2. Payment Processing</h2>
            <p style={styles.paragraph}>
              Payments are processed by Stripe, Inc. By using payment features of the Service, you
              agree to Stripe's applicable terms and policies. Stripe is responsible for processing
              payments and transferring funds through the banking system.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>3. Payment Timing</h2>
            <p style={styles.paragraph}>
              Payment initiation does not guarantee immediate receipt of funds. Settlement times
              vary based on payment method, banking networks, and factors outside our control.
            </p>
          </div>

          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>4. Fees</h2>
            <p style={styles.paragraph}>
              Certain payment methods may incur processing fees, which will be disclosed prior to
              completion.
            </p>
          </div>

          <div style={{ ...styles.section, marginBottom: 0 }}>
            <h2 style={styles.sectionTitle}>5. No Fiduciary Relationship</h2>
            <p style={{ ...styles.paragraph, marginBottom: 0 }}>
              The Service does not create a fiduciary, banking, or trust relationship between users
              and the Company.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
